import { Component, inject, Signal } from '@angular/core';
import { TranslatableComponent } from 'src/app/core/i18n/TranslatableComponent';
import { getTranslationProvider } from 'src/app/core/i18n/getTranslationProvider';
import { TranslatableStringType } from 'src/app/core/i18n/types';
import { LundifySubscriptionResponse } from 'src/app/core/state/types/lundify-subscription-response.types';
import { LundifySubscriptionFacade } from '../services/lundify-subscription.facade';

@Component({
  selector: 'app-subscription-expense',
  templateUrl: './expense.component.html',
  providers: [getTranslationProvider('ExpenseComponent')],
})
export class ExpenseComponent extends TranslatableComponent {
  private lundifySubscriptionFacade = inject(LundifySubscriptionFacade);
  private i18n: {
    shortUsersLabel: TranslatableStringType;
    shortUserLabel: TranslatableStringType;
    usersLabel: TranslatableStringType;
    userLabel: TranslatableStringType;
  } = {
    shortUsersLabel: '' as TranslatableStringType,
    shortUserLabel: '' as TranslatableStringType,
    usersLabel: '' as TranslatableStringType,
    userLabel: '' as TranslatableStringType,
  };

  protected override onTranslationsLoaded(): void {
    this.i18n = {
      shortUsersLabel: this.translate('shortUsersLabel'),
      shortUserLabel: this.translate('shortUserLabel'),
      usersLabel: this.translate('usersLabel'),
      userLabel: this.translate('userLabel'),
    };
  }

  get subscriptionExpense(): Signal<LundifySubscriptionResponse['subscriptionExpenseSnapshot'] | null> {
    return this.lundifySubscriptionFacade.expenseInformation;
  }

  get bundleExpense() {
    return this.subscriptionExpense()?.bundleExpenseSnapshot || null;
  }

  get moduleExpenses() {
    return this.subscriptionExpense()?.moduleExpenseSnapshot || [];
  }

  get integrationExpenses() {
    return this.subscriptionExpense()?.integrationExpenseSnapshot || [];
  }

  get totalAmountBilled() {
    return this.subscriptionExpense()?.totalAmountBilled || 0;
  }

  get isMiniPackage() {
    const bundleProductId = this.lundifySubscriptionFacade.bundleId();
    return bundleProductId.toLowerCase().includes('mini');
  }

  get pricePrefix(): string {
    return this.lundifySubscriptionFacade.countryCode() === 'SE' ? '' : '€ ';
  }

  get priceSuffix(): string {
    return this.lundifySubscriptionFacade.countryCode() === 'SE' ? ' kr' : '';
  }

  get isLoading(): Signal<boolean> {
    return this.lundifySubscriptionFacade.isLoading;
  }

  getUserLabel(quantity: number): string {
    return quantity > 1 ? this.i18n.shortUsersLabel : this.i18n.shortUserLabel;
  }

  getFullUserLabel(quantity: number): string {
    return quantity > 1 ? this.i18n.usersLabel : this.i18n.userLabel;
  }
}
